import React from "react"
import { Input, Select } from "antd"
import {
  SearchOutlined,
  UnorderedListOutlined,
  AppstoreOutlined,
} from "@ant-design/icons"
import { translations } from "../../utils/Translation/staticTranslation"
import "./PlansPricing.css"

const { Option } = Select

const PlansPricingFilters = ({
  searchValue,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  typeFilter,
  onTypeFilterChange,
  categoryFilter,
  onCategoryFilterChange,
  viewMode,
  onViewModeChange,
}) => {
  const lang = localStorage.getItem("language") || "ar"
  const t = translations[lang]?.plansPricingPage

  return (
    <div className="plans-pricing-filters-container">
      <Input
        placeholder={t?.search_plans || "Search plans..."}
        prefix={<SearchOutlined className="plans-pricing-search-icon" />}
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        className="plans-pricing-search-input"
      />

      <div className="plans-pricing-filters-right">
        <Select
          value={statusFilter}
          onChange={onStatusFilterChange}
          className="plans-pricing-filter-select plans-pricing-filter-select-wrapper"
          size="large"
        >
          <Option value="all">
            {t?.filters?.all_status || "All Status"}
          </Option>
          <Option value="Active">
            {t?.filters?.status?.active || "Active"}
          </Option>
          <Option value="Inactive">
            {t?.filters?.status?.inactive || "Inactive"}
          </Option>
          <Option value="Draft">
            {t?.filters?.status?.draft || "Draft"}
          </Option>
        </Select>

        <Select
          value={typeFilter}
          onChange={onTypeFilterChange}
          className="plans-pricing-filter-select plans-pricing-filter-select-wrapper"
          size="large"
        >
          <Option value="all">
            {t?.filters?.all_types || "All Types"}
          </Option>
          <Option value="One-Time">
            {t?.filters?.types?.one_time || "One-Time"}
          </Option>
          <Option value="Subscription">
            {t?.filters?.types?.subscription || "Subscriptions"}
          </Option>
        </Select>

        <Select
          value={categoryFilter}
          onChange={onCategoryFilterChange}
          className="plans-pricing-filter-select plans-pricing-filter-select-wrapper"
          size="large"
        >
          <Option value="all">
            {t?.filters?.all_categories || "All Categories"}
          </Option>
          <Option value="standard">
            {t?.filters?.categories?.standard || "Standard"}
          </Option>
          <Option value="organization">
            {t?.filters?.categories?.organization || "Organization"}
          </Option>
        </Select>

        <div className="plans-pricing-view-toggle">
          <button
            type="button"
            className={`plans-pricing-view-toggle-btn ${
              viewMode === "list" ? "active" : ""
            }`}
            onClick={() => onViewModeChange("list")}
          >
            <UnorderedListOutlined />
            <span>{t?.view_list || "List"}</span>
          </button>
          <button
            type="button"
            className={`plans-pricing-view-toggle-btn ${
              viewMode === "grid" ? "active" : ""
            }`}
            onClick={() => onViewModeChange("grid")}
          >
            <AppstoreOutlined />
            <span>{t?.view_grid || "Grid"}</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default PlansPricingFilters
